import { utils,ethers } from 'ethers'

import _abi from './abi/limitOrder'

const GelatoLimitOrders__factory = {
    connect: (address:string, signerOrProvider?:any) => new ethers.Contract(address, _abi, signerOrProvider),
    createInterface: () => new utils.Interface(_abi),
    _abi
}

export default GelatoLimitOrders__factory;